import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { trackVisit } from '@/lib/tracking';

export function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const email = searchParams.get('email');

  useEffect(() => {
    trackVisit({
      page: window.location.pathname,
      email,
    }).catch(err => console.error('Visitor tracking error:', err));
  }, []);

  useEffect(() => {
    async function unsubscribe() {
      if (!email) {
        setStatus('error');
        return;
      }

      try {
        const response = await fetch('https://fojubejaymmnxqsulnql.supabase.co/rest/v1/unsubscribed_emails', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZvanViZWpheW1tbnhxc3VsbnFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4MDgzMjAsImV4cCI6MjA5MjM4NDMyMH0.apMhzr-otgR4pVLFswH3-0dRJFNxRYP7OP_cajZIaQk',
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZvanViZWpheW1tbnhxc3VsbnFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4MDgzMjAsImV4cCI6MjA5MjM4NDMyMH0.apMhzr-otgR4pVLFswH3-0dRJFNxRYP7OP_cajZIaQk',
          },
          body: JSON.stringify({ email }),
        });

        if (response.ok) {
          setStatus('success');
        } else if (response.status === 409) {
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch (err) {
        console.error('Unsubscribe error:', err);
        setStatus('error');
      }
    }

    unsubscribe();
  }, [email]);

  return (
    <div className="max-w-md mx-auto py-12 text-center">
      {status === 'loading' && (
        <div>
          <h1 className="text-2xl font-serif mb-4">Processing...</h1>
          <p className="text-text-secondary">Please wait.</p>
        </div>
      )}

      {status === 'success' && (
        <div>
          <h1 className="text-2xl font-serif mb-4 text-green-600">Unsubscribed</h1>
          <p className="text-text-secondary">
            You have been successfully unsubscribed from patent sale notifications.
          </p>
        </div>
      )}

      {status === 'error' && (
        <div>
          <h1 className="text-2xl font-serif mb-4 text-red-600">Error</h1>
          <p className="text-text-secondary">
            {email
              ? 'An error occurred. You may already be unsubscribed.'
              : 'No email address provided.'}
          </p>
        </div>
      )}
    </div>
  );
}